/**
 * @fileoverview 通用弹层
 * @filetype ES6
 * @author zhenn
 */
import Dialog from 'c-dialog';
import lang from '../lang/index';

const templateList = [
    '<div class="widget-dialog">',
        '<div class="widget-dialog-content">{{content}}</div>',
        '<div class="widget-dialog-footer">',
            '<button type="button" class="close" data-id="close">' + lang.template('取消') + '</button>',
            '<button type="button" class="confirm" data-id="confirm">' + lang.template('知道了') + '</button>',
        '</div>',
    '</div>',
    '<style type="text/css">',
        '.widget-dialog { z-index:100; position: absolute; background: #a0aede; border: 0 none; height: 4rem; top: 50%; font-size: 0.5rem; left: 50%; width: 7rem; margin: -2rem 0 0 -3.5rem; border-radius: 0.21875rem; color:#fff;}',
        '.widget-dialog-content { text-align: center; width: 7rem; height: 2.5rem; display:table-cell; vertical-align:middle; }',
        '.widget-dialog-footer { height: 1rem;text-align:center;}',
        '.widget-dialog-footer button {  width: 2.8125rem; border: 0.03125rem solid #eee; border-radius: 0.15625rem; height: 1rem; color: #a0aede; font-size:0.5rem; background: #fff; }',
        '.widget-dialog-footer button.confirm { background: #fff;}',
        '.widget-dialog-footer button.close {margin-right: 0.375rem;}',
    '</style>'
];

export default Dialog.extend({
    defaults : {
        template : templateList.join('')
    }
});


// WEBPACK FOOTER //
// ./js/global/notification.js